var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav",attrs:{"id":"nav-sidebar"}},[_c('ul',_vm._l((_vm.navigation),function(nav,index){return _c('NavElement',{key:index,ref:"navElements",refInFor:true,attrs:{"nav":nav}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }